import axios from 'axios'
import querystring from 'querystring'

// initial state

const state = {
  fightCategories: null,
  formsCategories: null,
  eventFightCategories: null,
  eventFormsCategories: null,
  fightRankings: null,
  formsRankings: null,
  fightResults: null,
  formsResults: null
}

// getters
const getters = {
  fightCategories: state => state.fightCategories,
  formsCategories: state => state.formsCategories,
  eventFightCategories: state => state.eventFightCategories,
  eventFormsCategories: state => state.eventFormsCategories,
  formsRankings: state => state.formsRankings,
  fightRankings: state => state.fightRankings,
  fightResults: state => state.fightResults,
  formsResults: state => state.formsResults,
  participants: state => {
    if (state.fightResults) {
      return state.fightResults.competitors.filter(x => x.ranking === '0')
    }
    if (state.formsResults) {
      return state.formsResults.competitors.filter(x => x.ranking === '0')
    }
    return null
  }
}

// actions
const actions = {
  getFightCategories: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCategoriesFightLadder,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_FIGHT_CATEGORIES', response.data.categoriesFight)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getFormsCategories: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCategoriesFormsLadder,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_FORMS_CATEGORIES', response.data.categoriesForms)
        console.log(response)
      }
      )
      .catch((error) => console.log(error))
    },
  getEventFightCategories: function (context, eventId) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCatFightIncCompetitorCountByEventId,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        eventId: eventId
      })
    )
    .then(
      (response) => {
        context.commit('SET_EVENT_FIGHT_CATEGORIES', response.data.categoriesFight)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getEventFormsCategories: function (context, eventId) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCatFormsIncCompetitorCountByEventId,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        eventId: eventId
      })
    )
    .then(
      (response) => {
        context.commit('SET_EVENT_FORMS_CATEGORIES', response.data.categoriesForms)
        console.log(response)
      }
      )
      .catch((error) => console.log(error))
    },
    getFightRankings: function (context, id) {
      return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getRankingFightByCatId,
      // formData NO NATIVE SUPPORT
      querystring.stringify(
        {
          user: context.rootGetters['config'].API.user,
          password: context.rootGetters['config'].API.password,
          catId: id
        })
      )
      .then(
        (response) => {
          context.commit('SET_FIGHT_RANKINGS', response.data.rankingData)
          console.log(response)
        }
      )
      .catch((error) => console.log(error))
    },
    getFormsRankings: function (context, id) {
      return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getRankingFormsByCatId,
      // formData NO NATIVE SUPPORT
      querystring.stringify(
        {
          user: context.rootGetters['config'].API.user,
          password: context.rootGetters['config'].API.password,
          catId: id
        })
        )
        .then(
        (response) => {
          context.commit('SET_FORMS_RANKINGS', response.data.rankingData)
          console.log(response)
        }
        )
        .catch((error) => console.log(error))
      },
      getFightResults: function (context, payload) {
        return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getResultFightByEventIdCatId,
        // formData NO NATIVE SUPPORT
        querystring.stringify(
          {
            user: context.rootGetters['config'].API.user,
            password: context.rootGetters['config'].API.password,
            catId: payload.catId,
            eventId: payload.eventId
          })
        )
        .then(
          (response) => {
            context.commit('SET_FIGHT_RESULTS', response.data.dataFight)
            console.log(response)
          }
        )
        .catch((error) => console.log(error))
      },
      getFormsResults: function (context, payload) {
        return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getResultFormsByEventIdCatId,
        // formData NO NATIVE SUPPORT
        querystring.stringify(
          {
            user: context.rootGetters['config'].API.user,
            password: context.rootGetters['config'].API.password,
            catId: payload.catId,
            eventId: payload.eventId
          })
        )
        .then(
          (response) => {
            context.commit('SET_FORMS_RESULTS', response.data.dataForms)
            console.log(response)
          }
        )
        .catch((error) => console.log(error))
      },
}

// mutations
const mutations = {
  SET_FIGHT_CATEGORIES (state, data) {
    state.fightCategories = data
    console.log('SET_FIGHT_CATEGORIES')
    console.log(state.fightCategories)
  },
  SET_FORMS_CATEGORIES (state, data) {
    state.formsCategories = data
    console.log('SET_FORMS_CATEGORIES')
    console.log(state.formsCategories)
  },
  SET_EVENT_FIGHT_CATEGORIES (state, data) {
    state.eventFightCategories = data
    console.log('SET_EVENT_FIGHT_CATEGORIES')
    console.log(state.eventFightCategories)
  },
  SET_EVENT_FORMS_CATEGORIES (state, data) {
    state.eventFormsCategories = data
    console.log('SET_EVENT_FORMS_CATEGORIES')
    console.log(state.eventFormsCategories)
  },
  SET_FIGHT_RANKINGS (state, data) {
    state.fightRankings = data
    console.log('SET_FIGHT_RANKINGS')
    console.log(state.fightRankings)
  },
  SET_FORMS_RANKINGS (state, data) {
    state.formsRankings = data
    console.log('SET_FORMS_RANKINGS')
    console.log(state.formsRankings)
  },
  SET_FIGHT_RESULTS (state, data) {
    state.fightResults = data
    console.log('SET_FIGHT_RESULTS')
    console.log(state.fightResults)
  },
  SET_FORMS_RESULTS (state, data) {
    state.formsResults = data
    console.log('SET_FORMS_RESULTS')
    console.log(state.formsResults)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
